export default {
  // Generic error messages
  networkError: "Грешка в мрежата. Моля, проверете връзката си и опитайте отново.",
  serverError: "Грешка в сървъра. Моля, свържете се с поддръжката, ако проблемът продължава.",
  authError: "Сесията изтече. Моля, влезте отново.",
  validationError: "Невалидни данни. Моля, проверете въведеното.",
  timeoutError: "Изтекло време за заявката. Моля, опитайте отново.",
  unknownError: "Възникна неочаквана грешка. Моля, опитайте отново.",

  // Operation-specific errors
  fetchFailed: "Неуспешно зареждане на данни. Моля, опитайте отново.",
  saveFailed: "Неуспешно запазване на промените. Моля, опитайте отново.",
  updateFailed: "Неуспешно актуализиране. Моля, опитайте отново.",
  deleteFailed: "Неуспешно изтриване. Моля, опитайте отново.",
  createFailed: "Неуспешно създаване. Моля, опитайте отново.",
  publishFailed: "Неуспешно публикуване. Моля, опитайте отново.",

  // Common actions
  retry: "Опитай отново",
  cancel: "Отказ",
  dismiss: "Затвори",
};
